import { render } from "./BeritaDetail.vue?vue&type=template&id=d8e936ec"
import script from "./BeritaDetail.vue?vue&type=script&lang=js"
export * from "./BeritaDetail.vue?vue&type=script&lang=js"

import "./BeritaDetail.vue?vue&type=style&index=0&id=d8e936ec&lang=css"
script.render = render

export default script